import fillProductKey from './middlewares/fillProductKey'
import populate from './middlewares/populate'
import productsD from './ui/productsD'

module.exports = {
  model: 'products',
  name: 'D-藥水資料',
  ui: productsD,
  middlewares: [populate, fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/productsD.js